import { QueryCache, QueryClient } from '@tanstack/react-query';
import { getLogger } from '../../../application/instrument/useLogger';
import { getErrorFromUnknown } from '../../../application/common/helpers/errors';

const queryCache = new QueryCache({
  onError: (error, query) => {
    const errorFromUnknown = getErrorFromUnknown(error);
    if (typeof query.meta?.errorMessage === 'string') {
      errorFromUnknown.message = `${query.meta.errorMessage} Error: ${errorFromUnknown.message}`;
    }
    console.error(errorFromUnknown);
    getLogger().pushError(errorFromUnknown);
  }
});

export const queryClient = new QueryClient({
  queryCache,
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});
